/* fx-tip.js - tooltips that close, and sheets that dismiss.

   THE PROBLEM, AND IT IS THE SAME ONE TWICE. Both help bubbles on this store
   are opened by CSS alone:

     .fx-vtip:focus-within .fx-vtip__box   { visibility: visible }
     .vin-fx-help:hover::after,
     .vin-fx-help:focus::after             { visibility: visible }

   With a mouse that is exactly right. On a phone there is no hover, and a tap
   is a focus, so the tip opens on the first tap and then has no way to close:
   the second tap lands on an element that is already focused, focus does not
   move, and the tip stays up. The only thing that shuts it is tapping
   somewhere else, which is what was reported. A tip you cannot dismiss with
   the control that opened it is a control that only half works.

   SO ON TOUCH THE CLASS DOES THE WORK, NOT THE FOCUS. This file toggles
   .is-open, and fx-ios-j.css suppresses the focus and hover rules under
   @media (hover: none) so they cannot hold the tip open behind its back.
   Keyboard users on a real pointer device keep the focus behaviour they had,
   untouched, because that media query does not apply to them.

   Three ways out, which is what people actually try: the control itself,
   anywhere else on the page, and Escape.

   THE LISTENER CAPTURES. The extension binds its own handlers to some of
   these controls and a bubble phase listener would run after them. This is
   the same reason fx-cart.js captures, and the note there explains it at
   length.

   IT ALSO DISMISSES A SHEET FROM ITS SCRIM. The Change trailer sheet dims the
   page behind it with .fx-where-scrim and then ignored taps on it, so the
   only way out was the small x. Tapping the dimmed area is the first thing
   anyone tries. The scrim now finds the sheet's own close control and presses
   it, rather than reaching into the sheet's state, so whatever the extension
   does on close still happens. */
(function () {
  'use strict';

  if (window.fxTipOn) return;
  window.fxTipOn = 1;

  /* .ident-tip is the (i) beside each question in the I don't know my model
     quiz. It had the same one way behaviour and was never on this list. */
  var TIPS = '.fx-vtip, .vin-fx-help, .ident-tip';
  var SCRIMS = '.fx-where-scrim, .vin-fx-fsheet-scrim, .ident-scrim, .vin-fx-sheet-scrim';
  var CLOSERS = '[data-fx-sheet-close], [data-selector-close], .vin-fx-fsheet-x, ' +
                '.vin-fx-sheet-x, .ident-sheet-x, .fx-where-close';

  function closeTips(except) {
    var open = document.querySelectorAll('.fx-vtip.is-open, .vin-fx-help.is-open, .ident-tip.is-open');
    for (var i = 0; i < open.length; i++) {
      if (open[i] === except) continue;
      open[i].classList.remove('is-open');
      try { open[i].blur(); } catch (e) {}
    }
  }

  function onScreen(el) {
    if (!el || el.offsetParent === null) return false;
    var r = el.getBoundingClientRect();
    return r.width > 4 && r.height > 4;
  }

  /* Press the sheet's own close control. Never unset its state by hand: the
     extension hangs its own work off that button. */
  function dismissSheet() {
    var all = document.querySelectorAll(CLOSERS);
    for (var i = 0; i < all.length; i++) {
      if (onScreen(all[i])) { all[i].click(); return true; }
    }
    var labelled = document.querySelectorAll('[aria-label]');
    for (var j = 0; j < labelled.length; j++) {
      var lab = (labelled[j].getAttribute('aria-label') || '').toLowerCase();
      if (lab.indexOf('close') === -1) continue;
      if (!onScreen(labelled[j])) continue;
      if (labelled[j].closest('.vin-modal-toolbar')) continue;   /* not the modal's own x */
      labelled[j].click();
      return true;
    }
    return false;
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;

    var tip = t.closest(TIPS);
    if (tip) {
      ev.preventDefault();
      ev.stopPropagation();
      var wasOpen = tip.classList.contains('is-open');
      closeTips(tip);
      if (wasOpen) {
        tip.classList.remove('is-open');
        try { tip.blur(); } catch (e) {}
      } else {
        tip.classList.add('is-open');
      }
      return;
    }

    closeTips(null);

    if (t.matches && t.matches(SCRIMS)) {
      ev.preventDefault();
      if (!dismissSheet()) {
        document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
      }
    }
  }, true);

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape') closeTips(null);
  });
})();
